// import React, { useEffect,  } from 'react';
import React, { useState, useEffect } from 'react';
import './dashboard.css';
import http from '../../services/http-service'
import { Box, Card, CardContent, Typography, CardActions, Grid, Slider } from "@material-ui/core";
import Moment from 'moment';
import { Chart, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, registerables } from 'chart.js';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { ToastContainer, toast } from 'react-toastify';
import Select from '@mui/material/Select';
import { useLocation } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useHistory } from 'react-router-dom'

ChartJS.register(...registerables);

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}


function Dashboard(props) {

    const userInfo = JSON.parse(localStorage.getItem('loginUser'))
    let query = useQuery();
    const [dashboardData, setDashBoardData] = useState([])
    const [donutChartdata, setDonutChartdata] = useState([]);
    const [graphChartData, setGraphChartData] = useState([]);
    const [employerList, setEmployerList] = useState([]);
    const [employer, setEmployer] = useState({})
    const [open, setOpen] = useState(false);
    const [employerCode, setEmployerCode] = useState('');
    const history = useHistory()


    useEffect(() => {
        if (query.get("id")) {
            setEmployerCode(query.get("id"))
        } else {
            setEmployerCode('')
        }
        if (userInfo.roles !== 3)
            getEmployerData()
        if (userInfo.roles === 3) {
            setEmployerCode(userInfo.employer_code)
            getEmployerDataById(userInfo.id)
            getDashboardchart1(userInfo.employer_code)
        }
        // eslint-disable-next-line    
    }, [props])


    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    const getEmployerData = () => {
        handleToggle()
        http('admin/company_list/', 'GET')
            .then(res => {
                if (res.data.status) {
                    if (Array.isArray(res.data.data))
                        setEmployerList(res.data.data)
                    else {
                        let arr = []
                        arr.push(res.data.data)
                        setEmployerList(arr)
                    }

                }
                else {
                    toast.error(res.data.message, {
                        toastId: "toastId1"
                    })
                }
                handleClose()
            },
                err => {
                    handleClose()
                })
    }

    const getEmployerDataById = (id) => {
        handleToggle()
        http('admin/company_list/', 'GET', '', { id: id })
            .then(res => {
                if (res.data.status) {
                    setEmployer(res.data.data)
                }
                else {
                    toast.error(res.data.message, {
                        toastId: "toastId2"
                    })
                }
                handleClose()
            },
                err => {
                    handleClose()
                    console.log('err....', err)
                })
    }


    const getDashboardchart1 = (id) => {
        handleToggle()
        let params = {
            'employer_code': id
        }
        http('employer/dashboard/', 'GET', '', params)
            .then(res => {
                console.log('employer', res.data.status);
                if (res.data.status == true) {
                    setDashBoardData(res.data.data)
                    setDonutChartdata(res.data.data.employee_status_list[0])
                    setGraphChartData(res.data.data.tot_num_cashouts_count_list[0])
                    // setchartdata(res.data)
                }
                else {
                    toast.error(res.data.message, {
                        toastId: "toastId2"
                    })
                }
                handleClose()
            },
                (err) => {
                    handleClose()
                    console.log('err....', err.Error)
                });
    }


    // const getDashboard = () => {
    //     http('employer/dashboard/', 'GET')
    //         .then(res => {
    //             console.log('employer data is as ::', res);
    //         },
    //             (err) => {
    //                 console.log('err....', err.Error)
    //             });
    // }

    const donoughtChartDataValue = {
        labels: donutChartdata ? donutChartdata.labels : [],
        datasets: [
            {
                pointStyle: 'circle',
                pointRadius: 1,
                data: donutChartdata ? donutChartdata.data : [],
                backgroundColor: [
                    'rgb(119, 93, 222)',
                    'rgb(53, 207, 151)',
                    'rgb(237, 207, 47)',
                    'rgb(46, 34, 118)'
                ]
            },
        ]
    }




    // const getLastSevenDates = () => {
    //     const today = Moment();
    //     const res = Array(7).fill().map(
    //         () => today.subtract(1, 'd').format('DD/MM/YYYY')
    //     );

    //     return res.reverse();
    // }

    const barChartOptions = {
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    ticks: {
                        // The y-axis value will start from zero
                        beginAtZero: true,
                    },
                },
            ],
        },

        plugins: {
            title: {
                display: true,
                align: 'center',
                text: 'Total number of cashouts',
                font: {
                    weight: 'bold',
                    size: '15px'
                }
            },
            legend: {
                display: false //This will do the task
            }
        }
    }


    const barChartDataValue = {
        labels: graphChartData ? graphChartData.lables : [],
        datasets: [{
            // label: 'Total number of cashouts',
            data: graphChartData ? graphChartData.data : [],
            backgroundColor: [
                'rgb(69, 110, 217)'
            ]
        }]
    }



    return (
        <div className="App mainAppDiv" >
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Grid container spacing={2}>
                <Grid item xs={6} md={9}>
                    <Typography variant="h1" component="h1" className='settingHeading'>
                        Dashboard
                    </Typography>
                </Grid>
                <Grid item xs={6} md={3}>
                    {userInfo.roles !== 3 ? (
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Select Employer</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                name='employer' id="employer"
                                value={employerCode}
                                label="Please select employer"
                                onChange={(e) => {
                                    setEmployerCode(e.target.value)
                                    getDashboardchart1(e.target.value)
                                    // setValue('1');
                                    // setViewPayAttributes(false)
                                    let employer = employerList.find(elem => { return elem.employer_id === e.target.value })
                                    setEmployer(employer)
                                }}
                            >
                                <MenuItem value="" disabled="true">Please select</MenuItem>
                                {
                                    employerList.map((data, index) => (
                                        <MenuItem key={'data.code' + index} value={data.employer_id}>{data.name + " (" + data.employer_id + ")"}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    ) : (
                        <div></div>
                    )}

                </Grid>
            </Grid>



            {employerCode ? (
                <>

                    <Grid container spacing={2} >
                        <Grid item xs={12} sm={6} md={3} lg={3} >
                            <Box className='boxContentCstm' >
                                <Card elevation={10}
                                    className='boxContentCstmCard' >
                                    <CardContent className='AmtTrans' >
                                        <Typography variant="h6"
                                            className='AmtTransInner' > Amount Transferred </Typography> </CardContent > <CardActions className='AmtTotal' >
                                        <h2 className='AmtTotalInnre' > ₦{dashboardData ? dashboardData.amount_transfer : 0} < sub > <span > Total </span></sub > </h2> </CardActions >
                                    <CardContent className='pastDays' > past 7 days </CardContent> </Card > </Box>

                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={3} >
                            <Box >
                                <Card elevation={10} className='boxContentCstmCard' >
                                    <CardContent className='AmtTrans' >
                                        <Typography variant="h6"
                                            className='AmtTransInner' > Net Earnings Reported </Typography> </CardContent >
                                    <CardActions className='AmtTotal' >
                                        <h2 className='AmtTotalInnre' > {dashboardData && dashboardData.gross_earnings_reported ? Math.floor(dashboardData.gross_earnings_reported) : 0} % < sub > <span > of Users </span></sub > </h2> </CardActions >
                                    <CardContent className='pastDays' > past 24 hours </CardContent>
                                </Card > </Box>

                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={3} >
                            <Box >
                                <Card elevation={10}
                                    className='boxContentCstmCard' >
                                    <CardContent className='AmtTrans' >
                                        <Typography variant="h6"
                                            className='AmtTransInner' > Enrollment </Typography> </CardContent>
                                    <CardActions className='AmtTotal' >
                                        <h2 className='AmtTotalInnre' > {dashboardData ? dashboardData.enrollment_user : 0} % < sub > <span> of Eligible Users </span></sub > </h2> </CardActions >
                                    <CardContent className='pastDays' > as of today </CardContent> </Card> </Box>

                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={3} >
                            <Box >
                                <Card elevation={10}
                                    className='boxContentCstmCard' >
                                    <CardContent className='AmtTrans' >
                                        <Typography variant="h6"
                                            className='AmtTransInner' > Adoption </Typography> </CardContent > <CardActions className='AmtTotal' >
                                        <h2 className='AmtTotalInnre' > {dashboardData ? dashboardData.adoption_user : 0} % < sub > < span > of Eligible Users </span></sub > </h2>
                                    </CardActions >
                                    <CardContent className='pastDays' > as of today </CardContent>
                                </Card > </Box> </Grid > </Grid>

                    <Grid container spacing={0} className='my-20 dashboardUserList' >
                        <Grid item xs={12} sm={6} md={3} lg={3} >
                            <Box >
                                <Card className='cardNoEmp' >
                                    <CardContent className='no_emp' >
                                        <Typography variant="h6" className='no_empl' > Number of Employees </Typography>
                                        <span className='no_emplo' > {dashboardData ? dashboardData.total_active_employee : 0} </span>

                                    </CardContent>
                                    <span className='ActiveSpan' > Active </span>

                                    <Box display="flex"
                                        flexDirection="column"
                                        m={10}
                                        className='sliderBoxDiv' >
                                        <Slider />
                                        <div className='InactiveDiv' >
                                            <span className='InactiveDivSpan' > Inactive </span> <span className='spanTextEnd InactiveDivSpan' > {dashboardData ? dashboardData.total_inactive_employee : 0} </span>
                                        </div > </Box> </Card > </Box> </Grid >
                        <Grid item xs={12} sm={6} md={3} lg={3} >
                            <Box >
                                <Card className='cardNoEmp' >
                                    <CardContent className='no_emp' >
                                        <Typography variant="h6"
                                            className='no_empl' > Days Left Until </Typography>
                                        <span className='no_emploBlue' style={{color:"#3498db"}} > {dashboardData ? dashboardData.days_till_payday : 0} </span>
                                    </CardContent > <span className='ActiveSpan' > Days Till Payday </span> <Box display="flex"
                                        flexDirection="column"
                                        m={10}
                                        className='sliderBoxDiv sliderBoxDivBlue' >
                                        <Slider />
                                        <div className='InactiveDiv' >
                                            <span className='InactiveDivSpan' > Days Till Cut - Off </span>
                                            <span className='spanTextEnd InactiveDivSpan' > {dashboardData ? dashboardData.days_till_cutt_off : 0} </span> </div > </Box> </Card > </Box>

                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={3} >
                            <Box >
                                <Card className='cardNoEmp' >
                                    <CardContent className='no_emp' >
                                        <Typography variant="h6"
                                            className='no_empl' > Total number of cashouts </Typography>
                                        <span className='no_emploRed' > {dashboardData ? dashboardData.total_number_of_cashouts : 0} </span>
                                    </CardContent >
                                    <span className='ActiveSpan' > Count </span> <Box display="flex"
                                        flexDirection="column"
                                        m={10}
                                        className='sliderBoxDiv sliderBoxDivRed' >
                                        <Slider />
                                        <div className='InactiveDiv' >
                                            <span className='InactiveDivSpan' > Amount </span>
                                            <span className='spanTextEnd InactiveDivSpan' > ₦{dashboardData ? dashboardData.total_cashouts_amount : 0} </span> </div > </Box> </Card > </Box>

                        </Grid> < Grid item xs={12} sm={6} md={3} lg={3} >
                            <Box >
                                <Card className='cardNoEmp' >
                                    <CardContent className='no_emp' >
                                        <Typography variant="h6"
                                            className='no_empl' > New Users </Typography> <
                                                span className='no_emploGreen' > {dashboardData ? dashboardData.joined_new_user : 0} </span>
                                    </CardContent > <span className='ActiveSpan' > Joined New User </span> <Box display="flex"
                                        flexDirection="column"
                                        m={10}
                                        className='sliderBoxDiv sliderBoxDivGreen' >
                                        <Slider />
                                        <div className='InactiveDiv' >
                                            <span className='InactiveDivSpan' > Change to Inactive </span> <span className='spanTextEnd InactiveDivSpan' > {dashboardData ? dashboardData.change_to_inactive_user : 0} </span> </div > </Box> </Card > </Box> </Grid >

                    </Grid>

                    <Grid container spacing={3}
                        justifyContent="center" >
                        <Grid item xs={12} sm={12} md={12} lg={5} >
                            <div className='mainGridDiv mainGridDivHeight' >
                                <div className='doughnutGrid'>
                                    {/* <img src={logo1}
                               className="App-logo"
                               alt="logo" /> */}

                                    <Chart type='doughnut' data={donoughtChartDataValue} options={{
                                        plugins: {
                                            title: {
                                                display: true,
                                                align: 'center',
                                                text: 'Employee Status',
                                                font: {
                                                    weight: 'bold',
                                                    size: '15px'
                                                }
                                            },
                                            legend: {
                                                labels: {
                                                    usePointStyle: true
                                                }
                                            },

                                        },
                                        cutoutPercentage: 80
                                    }
                                    } />
                                </div>
                            </div>
                        </Grid >
                        <Grid item xs={12} sm={12} md={12} lg={7} >
                            <div className='mainGridDiv mainGridDivHeight' >
                                {/* <img src={logo}
                           className="App-logo"
                           alt="logo" /> */}
                                <div className='barChartGrid'>
                                    <Bar data={barChartDataValue} options={barChartOptions} />
                                </div>
                            </div>
                        </Grid >
                    </Grid>
                </>

            ) : (
                <div className='recordNotFoundDiv'>
                    <h2>Please select employer first.</h2>
                </div >
            )}



        </div>
    )
}

export default Dashboard;


